import React from "react";
import { Outlet, useLocation, useNavigate, Navigate } from "react-router-dom";
import InnerBanner from "../components/inner_banner/InnerBanner";
import Sidebar from "../components/sidebar/Sidebar";
import "./Pages.css";

const Admission = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menu = [
    { name: "Admission - 2026", path: "admission-2026" },
    { name: "Schedule Guidline", path: "schedule-guidline" },
    { name: "Admission Procedure", path: "admission-procedure" },
    { name: "Course Wise Eligibility", path: "course-eligibilty" },
    // { name: "DNS- Female Sponsorship", path: "DNS" },
    { name: "Fee Structure", path: "fee-structure" },
    { name: "Scholarship Policy", path: "scholarships" },
    { name: "Brochure", path: "brochure" },
    { name: "FAQ's", path: "admission-faq" },
  ];

  const activeItem =
    menu.find((m) => location.pathname.includes(m.path))?.name || "Admission";

  // Mapping for title + background based on route
  const bannerDataMap = {
    "schedule-guidline": {
      title: "Schedule Guidline",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },

    "admission-procedure": {
      title: "Admission Procedure",
      bgImage: "/assets/images/inner_bnr/DSC_2308.jpg",
    },

    "course-eligibilty": {
      title: "Course Wise Eligibility",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },
    // DNS: {
    //   title: "DNS- Female Sponsorship",
    //   bgImage: "/assets/images/inner_bnr/DSC_2059.jpg",
    // },
    "fee-structure": {
      title: "Fee Structure",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },
    scholarships: {
      title: "Scholarship Policy",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },

    brochure: {
      title: "Brochure",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },
    "admission-faq": {
      title: "FAQ's",
      bgImage: "/assets/images/inner_bnr/inner_banner.jpg",
    },
  };

  //  Reusable function to fetch matching banner data
  const getBannerData = () => {
    const matchedKey = Object.keys(bannerDataMap).find((key) =>
      location.pathname.includes(key),
    );

    // If no match found → default to About MANET
    return (
      bannerDataMap[matchedKey] || {
        title: "Admission - 2026",
        bgImage: "/assets/images/inner_bnr/DSC_2165.jpg",
      }
    );
  };

  const { title, bgImage } = getBannerData();

  const subtitle = "Sailing Towards Excellence & a Brighter Future with MANET";

  return (
    <>
      <InnerBanner bgImage={bgImage} title={title} subtitle={subtitle} />

      <div className="page-layout">
        <Sidebar menuItems={menu} />

        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Admission;
